import React from 'react';

import Header from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentBalcaoDemanda from './ContentBalcaoDemanda';

const BalcaoDemanda = () => {
  return (
    <>
      <Header />
      <ContentBalcaoDemanda style={{ minHeight: '100%' }} />
      <Bottom style={{ bottom: '0', position: 'absolute' }} />
    </>
  );
};

export default BalcaoDemanda;
